import React, { useState, useEffect, useRef } from "react";

import "./ModalTest";
import { Carousel } from "react-responsive-carousel";
import "../Components/Slider.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useSelector } from "react-redux";

import LpForm from "../../packageDetailsPage/LpForm";

// import banner1 from "../../../Assets/newAsset/mobileSlider/bgMobile1.webp";
import banner11 from "../../../Assets/newAsset/mobileSlider/samanthaPhone.webp";
import banner2 from "../../../Assets/newAsset/mobileSlider/bgMobile2.webp";
import banner3 from "../../../Assets/newAsset/mobileSlider/bgMobile3.webp";
import { MdLocationOn } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";

const SliderMobile = ({ match }) => {
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const packageDetails = useSelector((state) => state.packageDetails);
  const { loading, packDetail } = packageDetails;

  //RESPONSIVE SCRREEN
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <Carousel
      autoPlay={false}
      showIndicators={false}
      showArrows={false}
      showStatus={false}
      verticalSwipe="natural"
      responsive={responsive}
      showThumbs={false}
      interval={2500}
      infiniteLoop={false}
      preventMovementUntilSwipeScrollTolerance={false}
      swipeScrollTolerance={100}
      stopOnHover={false}
      transitionTime={1000}
      
    > 
      <div className="imageDiv">
        <div className="BookNowBtn1">
          <div className="TexT1">
            <span className="red1">SMART FULL BODY</span>
            <span className="red1">CHECKUP</span>
            <span className="priceText">@ Just Rs. 699</span>
          </div>
          <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
            Book Test Now
          </button>
        </div>
        <LazyLoadImage
          id="bannerMob"
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a80a54f0-7a51-43a0-84f5-731bf2691a04.webp"
          alt="bannerphoto"
        />

        <Modal open={open} onClose={onCloseModal} center>
          <LpForm
            butname={"SUBMIT"}
            title={"Book Your Test"}
            position={"Banner"}
          />
        </Modal>
      </div>
      {/* <div className="imageDiv">
        <div className="BookNowBtn1">
          <div className="TexT1">
            <span className="smalltext">Now</span>
            <span className="red1">HYDERABAD</span>
            <span className="textwhite">WILL ALSO CHOOSE</span>
            <span className="BGwhite">TEST FROM HOME</span>
          </div>
          <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
            Find Health Packages
          </button>
        </div>
        <img className="photo" src={banner11} alt="bannerphoto" />
        <Modal open={open} onClose={onCloseModal} center>
          <LpForm
            butname={"SUBMIT"}
            title={"Book Your Test"}
            position={"Banner"}
          />
        </Modal>
      </div> */}
      {/* <div className="imageDiv">
        <div className="BookNowBtn">
          <div className="MobTexT">
            <span className="Mobdescr">
              Old Age Comes With Many Complications{" "}
            </span>
            <span className="MobHeAding">
              Let Arthritis<span className="redone">Not</span>
            </span>
            <span className="MobHeAding">Be One.</span>
            <span className="MobsubHeAding">
              Get Your Parents Tested Today!
            </span>
          </div>
          <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
            Book Arthritis Packages
          </button>
        </div>
        <LazyLoadImage
          className="photo"
          id="bannerMob"
          src={
            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/44d138a9-a8ef-4924-8cd4-4216cf38441f.webp"
          }
          alt="bannerphoto"
          delayTime="100"
        />
      </div>
      <div className="imageDiv">
        <div className="BookNowBtn">
          <div className="MobTexT">
            <span className="Mobdescr">
              Shield Your Loved Ones From Dengue And Malaria{" "}
            </span>
            <span className="MobHeAding">
              <span className="redtwo">Net</span>Your Loved{" "}
            </span>
            <span className="MobHeAding">Ones Today.</span>
            <span className="MobsubHeAding">Get Yourself Tested Today!</span>
          </div>
          <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
            Book Fever Profile Test
          </button>
        </div>

        <a
          href="https://youtu.be/AFRZXhFoXHE"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div>
            <LazyLoadImage
              id="bannerMob"
              className="photo"
              src={
                "https://staticcdn.redcliffelabs.com/media/gallary-file/None/60266978-8e7f-490c-bea5-2f8e87135e8e.webp"
              }
              alt="bannerphoto"
              delayTime="100"
            />
          </div>
        </a>
      </div>


      <div className="imageDiv">
        <div className="BookNowBtn">
          <div className="MobTexT">
            <span className="Mobdescr">
              Shield Your Loved Ones From Dengue And Malaria{" "}
            </span>
            <span className="MobHeAding">
              <span className="redtwo">Net</span>Your Loved{" "}
            </span>
            <span className="MobHeAding">Ones Today.</span>
            <span className="MobsubHeAding">Get Yourself Tested Today!</span>
          </div>
          <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
            Book Fever Profile Test
          </button>
        </div>

        
          <div>
            <LazyLoadImage
              id="bannerMob"
              className="photo"
              src={
                "https://staticcdn.redcliffelabs.com/media/gallary-file/None/b8749171-ab54-491b-8aae-bb44e1333550.webp"
              }
              alt="bannerphoto"
              delayTime="100"
            />
          </div>
    
      </div> */}
    </Carousel>
  );
};

export default SliderMobile;
